<template>
  <div
    ref="tooltip"
    v-clickout="hideTooltip"
    class="gfr-tooltip"
    @mouseenter="showTooltipHandle"
    @mouseleave="hideTooltipHandle"
    @click="toggleTooltip"
  >
    <slot />
    <div class="gfr-tooltip-wrapper" :style="contentStyle">
      <transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="transform scale-90 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-200 ease-out"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-90 opacity-0"
      >
        <div v-show="show" ref="tooltipCtx" :class="['gfr-tooltip-content', contentClass]">
          {{ message }}
        </div>
      </transition>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { rectInfo } from '~/components/gfr/utils/types'
import { getBoundingClientRect } from '~/components/gfr/utils'
const props = defineProps({
  message: {
    type: String,
    default: ''
  },
  trigger: {
    type: String as PropType<'click' | 'hover'>,
    default: 'hover'
  },
  placement: {
    type: String as PropType<'bottom-start' | 'bottom-end' | 'top-start' | 'top-end' | 'top' | 'bottom'>,
    default: 'bottom-start'
  },
  offsetX: {
    type: Number,
    default: 0
  },
  offsetY: {
    type: Number,
    default: 4
  },
  contentClass: String
})
const show = ref(false)
const rect = ref<null | rectInfo>(null)
const tooltip = ref<HTMLElement>()
const tooltipCtx = ref<HTMLElement>()
const tooltipCtxRect = ref<{ width: number; height: number } | null>(null)
let timer: any
/* TODO 与Dropdown Menu合并逻辑代码 */
const contentStyle = computed(() => {
  if (!rect.value || !tooltipCtxRect.value) return ''
  const { width, height, top, left, right, bottom } = rect.value
  const { width: ctxWidth, height: ctxHeight } = tooltipCtxRect.value || { width: 0, height: 0 }
  const [startX, endX, topY, bottomY] = [
    left + props.offsetX,
    right - props.offsetX - ctxWidth,
    top - props.offsetY - ctxHeight,
    top + height + props.offsetY
  ]
  const variable = {
    '--tooltip-transform-x': '0px',
    '--tooltip-transform-y': '0px'
  }
  switch (props.placement) {
    case 'bottom-start':
      startX + ctxWidth <= window.innerWidth
        ? (variable['--tooltip-transform-x'] = `${startX}px`)
        : (variable['--tooltip-transform-x'] = `${endX}px`)
      variable['--tooltip-transform-y'] = `${bottomY}px`
      break
    case 'top-start':
      startX + ctxWidth <= window.innerWidth
        ? (variable['--tooltip-transform-x'] = `${startX}px`)
        : (variable['--tooltip-transform-x'] = `${endX}px`)
      variable['--tooltip-transform-y'] = `${topY}px`
      break
    case 'top-end':
      endX + ctxWidth <= window.innerWidth
        ? (variable['--tooltip-transform-x'] = `${endX}px`)
        : (variable['--tooltip-transform-x'] = `${startX}px`)
      variable['--tooltip-transform-y'] = `${topY}px`
      break
    case 'bottom-end':
    default:
      endX + ctxWidth <= window.innerWidth
        ? (variable['--tooltip-transform-x'] = `${endX}px`)
        : (variable['--tooltip-transform-x'] = `${startX}px`)
      variable['--tooltip-transform-y'] = `${bottomY}px`
      break
  }
  return variable
})
function updateRect() {
  rect.value = getBoundingClientRect(tooltip.value as HTMLElement)
}
function showTooltipHandle() {
  if (Device().isMobile || props.trigger === 'click') return
  show.value = true
}
function hideTooltipHandle() {
  if (Device().isMobile || props.trigger === 'click') return
  show.value = false
}
function toggleTooltip() {
  show.value = !show.value
}
function hideTooltip() {
  if (Device().isMobile) show.value = false
}
async function getCtxRect() {
  await nextTick()
  return {
    width: tooltipCtx.value?.offsetWidth || 0,
    height: tooltipCtx.value?.offsetHeight || 0
  }
}
watch(
  () => show.value,
  async (val) => {
    if (val) {
      updateRect()
      !tooltipCtxRect.value && (tooltipCtxRect.value = await getCtxRect())
      window.addEventListener('resize', updateRect)
      window.addEventListener('scroll', throttle(updateRect, 10))
      if (Device().isMobile) {
        timer = setTimeout(() => {
          hideTooltip()
          clearTimeout(timer)
        }, 3000)
      }
    } else {
      window.removeEventListener('resize', updateRect)
      window.addEventListener('scroll', throttle(updateRect, 10))
      clearTimeout(timer)
    }
  }
)

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateRect)
  window.addEventListener('scroll', throttle(updateRect, 10))
})
</script>
<style scoped lang="scss">
@import './styles/index.scss';
</style>
